import axios from 'axios';
import '../config.js';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

const base = (accessPointId) => `${global.config.url}/AccessPoints/${accessPointId}/pinsettings`;

const pinSettingsApi = {
  get: async (accessPointId) => (await axios.get(base(accessPointId), authConfig())).data,
  save: async (accessPointId, settings) => axios.put(base(accessPointId), settings, authConfig()),
  remove: async (accessPointId) => axios.delete(base(accessPointId), authConfig()),
  getTargets: async (locationId, customerId) => {
    const endpoint = locationId
      ? `${global.config.url}/AccessPoints/ByLocation/${locationId}`
      : `${global.config.url}/AccessPoints/ByCustomer/${customerId}`;
    return (await axios.get(endpoint, authConfig())).data;
  },
};

export default pinSettingsApi;